export default {"src":"/_next/static/media/title-highlight.ce1d792e.svg","height":13,"width":95,"blurWidth":0,"blurHeight":0};